import { SignUp } from "@clerk/tanstack-react-start";
import { createFileRoute, redirect } from "@tanstack/react-router";

import { WorkEmailFormGuard } from "@/components/auth/work-email-guard";
import { useRedirectAfterAuth } from "@/hooks/use-redirect-after-auth";

export const Route = createFileRoute("/create/$")({
  beforeLoad: async ({ context }) => {
    if (context.userId) {
      throw redirect({ to: "/app" });
    }
  },
  component: CreateSignUpSplat,
});

const clerkVerifyAppearance = {
  elements: {
    rootBox: { width: "100%" },
    cardBox: { width: "100%", boxShadow: "none", overflow: "visible" },
    card: {
      padding: "0",
      boxShadow: "none",
      border: "none",
      backgroundColor: "transparent",
      gap: "0",
      width: "100%",
      overflow: "visible",
    },
    footer: { display: "none" },
    main: { padding: "0 2px" },
  },
};

function CreateSignUpSplat() {
  useRedirectAfterAuth();

  return (
    <div className="flex flex-1 items-center justify-center px-4">
      <div className="w-full max-w-100 rounded-2xl border bg-card px-8 py-10 shadow-sm">
        <WorkEmailFormGuard>
          <SignUp
            routing="path"
            path="/create"
            signInUrl="/sign-in"
            fallbackRedirectUrl="/app"
            appearance={clerkVerifyAppearance}
          />
        </WorkEmailFormGuard>
      </div>
    </div>
  );
}
